import { uploadData } from 'aws-amplify/storage';
import { fetchAuthSession } from 'aws-amplify/auth';
import { post } from 'aws-amplify/api';

const MAX_IMAGE_SIDE = 1920;

// Rekognition only accepts JPEG/PNG, so re-encode anything the browser can decode
// (e.g. WEBP, or HEIC on Safari) as a resized JPEG before uploading.
export const toJpeg = (file) => new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
        const scale = Math.min(1, MAX_IMAGE_SIDE / Math.max(img.width, img.height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(url);
        canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error('Could not convert image'))), 'image/jpeg', 0.92);
    };
    img.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error('Unsupported image format'));
    };
    img.src = url;
});

// Uploads to the user's private folder and resolves with the full S3 key once the upload has finished.
export const uploadPrivateImage = async (fileName, blob) => {
    await uploadData({
        key: fileName,
        data: blob,
        options: {
            contentType: 'image/jpeg',
            accessLevel: 'private'
        }
    }).result;
    const { identityId } = await fetchAuthSession();
    return `private/${identityId}/${fileName}`;
};

// Resolves with { matched, message } so the page can show the user what to do next.
export const compareFaces = async (idImageKey, userImageKey) => {
    try {
        const { body } = await post({
            apiName: "fundiiAPI",
            path: "/services/verify-identity",
            options: {
                body: { idImageKey, userImageKey },
                headers: { 'Content-Type': 'application/json' }
            }
        }).response;
        const response = await body.json();
        if (response.message.FaceMatches && response.message.FaceMatches.length > 0) {
            return { matched: true, message: 'Face Matched' };
        }
        return { matched: false, message: "Your face doesn't match the photo on your ID. Please try again in good lighting, looking straight at the camera." };
    } catch (error) {
        console.error('Error in facial recognition: ', error);
        const text = error?.message || '';
        if (text.includes('InvalidParameter')) {
            return { matched: false, message: "We couldn't find a clear face in one of the photos. Please make sure your ID photo shows your face clearly, and that your face is fully visible in the camera." };
        }
        if (text.includes('InvalidImageFormat') || text.includes('InvalidS3Object')) {
            return { matched: false, message: 'There was a problem reading your ID photo. Please upload it again as a JPG or PNG image.' };
        }
        return { matched: false, message: 'Something went wrong during face verification. Please try again.' };
    }
};
